module.exports =
{

  _init: function ()
  {

    APPLICATION._APPLICATION.search($('.js-url'))

    this.onChangePaid()

  },

  onChangePaid: function ()
  {

    $('#paid').not('.js-ignore').change(function ()
    {

      if ('2' === $(this).val())
      {
        $('#paid-dates').hide()
      }

      else
      {
        $('#paid-dates').show()
      }

    }).addClass('js-ignore')

  }

}